// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1XiSl","label":"LabeledBox_label__2fkVN"};